'use client'

import { Avatar, Icon, IconComponent } from '@graftcode/design-system'

import styles from '../../MobileMenu.module.scss'

interface MobileMenuAccountSectionProps {
  userName: string
  userEmail: string
  userAvatarUrl?: string
  projectName: string
  onAccountSelectorClick?: () => void
  onProjectSelectorClick?: () => void
  onHelpSelectorClick?: () => void
  showProjectSelector?: boolean
  showHelpSelector?: boolean
  helpLabel?: string
}

export function MobileMenuAccountSection({
  userName,
  userEmail,
  userAvatarUrl,
  projectName,
  onAccountSelectorClick,
  onProjectSelectorClick,
  onHelpSelectorClick,
  showProjectSelector = true,
  showHelpSelector = false,
  helpLabel = 'Help',
}: MobileMenuAccountSectionProps) {
  return (
    <div className={styles.accountSection}>
      <button className={styles.accountItem} onClick={onAccountSelectorClick}>
        <div className={styles.accountItemContent}>
          <Avatar size={32} src={userAvatarUrl} />
          <div className={styles.accountItemText}>
            <span className={styles.accountItemName}>{userName}</span>
            <span className={styles.accountItemEmail}>{userEmail}</span>
          </div>
        </div>
        <IconComponent icon={Icon.ChevronRightRegular} size={20} />
      </button>

      {showProjectSelector && (
        <button className={styles.accountItem} onClick={onProjectSelectorClick}>
          <div className={styles.accountItemContent}>
            <IconComponent icon={Icon.FolderRegular} size={20} />
            <span className={styles.projectName}>{projectName}</span>
          </div>
          <IconComponent icon={Icon.ChevronRightRegular} size={20} />
        </button>
      )}

      {showHelpSelector && (
        <button className={styles.accountItem} onClick={onHelpSelectorClick}>
          <div className={styles.accountItemContent}>
            <IconComponent icon={Icon.QuestionCircleRegular} size={20} />
            <span className={styles.projectName}>{helpLabel}</span>
          </div>
          <IconComponent icon={Icon.ChevronRightRegular} size={20} />
        </button>
      )}
    </div>
  )
}
